/**
 * CampaignSelect
 */
export { default as CampaignSelect } from './CampaignsPlatformSelect';

/**
 * CampaignFilter
 */
export { default as CampaignFilter } from './CampaignsPlatformFilter';

/**
 * CampaignLabel
 */
export { default as CampaignLabel } from './CampaignsPlatformLabel';

/**
 * EditCampaignAction
 * @deprecated Use CampaignsPlatformEditActionV2 for Trellis migration
 */
export { default as EditCampaignAction } from './CampaignsPlatformEditAction';

/**
 * EditCampaignActionV2
 */
export { default as EditCampaignActionV2 } from './CampaignsPlatformEditActionV2';

/**
 * CampaignsProvider
 */
export { default as CampaignsProvider, useCampaignsContext as useCampaigns } from './CampaignsProvider';

/**
 * useObjectTypeHasCampaignsAccess
 */
export { useObjectTypeHasCampaignsAccess } from './hooks/useFetchCampaignsAssociationSettings';

/**
 * useFetchCampaignsAssociationSettings
 */
export { useFetchCampaignsAssociationSettings } from './hooks/useFetchCampaignsAssociationSettings';

/**
 * useCampaignsPlatformEditActionMenuItem
 */
export { useCampaignsPlatformEditActionMenuItem } from './hooks/useCampaignsPlatformEditActionMenuItem';

/**
 * CampaignsFrameworkAppSettingsResponseTypes
 */

/**
 * mapObjectType
 */
export { mapObjectType } from './hooks/useFetchObjectPropertyDefinitions';

/**
 * fetchAndDeleteCampaignsAssociation
 */
export { fetchAndDeleteCampaignsAssociation } from './api/CampaignsAssociation';
export default 42;